import React, { useState } from 'react'
import { Pencil } from 'react-bootstrap-icons'
import { Button } from 'react-bootstrap'
import Edit from './edit'

const UserNameField = ({
    user={},
    canEdit,
}) => {
    const [ isEditing, setEditing ] = useState(false)

    if (isEditing) {
        return (<Edit user={user} onClose={() => setEditing(false)} />)
    }

    const renderEditButton = () => {
        if (!canEdit) {
            return null
        }

        return (
            <div style={{ cursor: 'pointer' }} onClick={() => setEditing(true)} ><Pencil /></div>
        )
    }

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        }}>
            <h2><strong>{user.lastName}, {user.firstName}</strong></h2>
            {renderEditButton()}
        </div>
    )
}

export default UserNameField